module.exports = __webpack_public_path__ + "img/8e36a48.png";